import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './keysbraga.module.scss';
import perfil from './src/perfil.png';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import TiktokIcon from '../../icons/tiktokIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';

const EMAIL = 'keylla.shay@gmail.com';
const WHATSAPP_NUMBER = '5541998881822';
const INSTAGRAM_URL = 'https://www.instagram.com/keysbraga/';
const TIKTOK_URL = 'https://www.tiktok.com/@keylasbraga';
const VITRINE_URL = 'https://collshp.com/clickey?view=storefront';
const MIDIAKIT_PATH = '/keysbraga/midiakit';
const ICON_COLOR = '#ffffff';

type ContactCard = {
    id: number;
    image: string;
    brand: string;
    email: string;
    whatsapp: string;
    modal: 'contact';
};

type LinkCard = {
    id: number;
    image: string;
    link: string;
    modal?: false;
};

type ModalCard = ContactCard;
type CardItem = ContactCard | LinkCard;

const cardImages: CardItem[] = [
    {
        id: 1,
        image: require('./src/cards/1.png'),
        brand: 'Contatos',
        email: EMAIL,
        whatsapp: WHATSAPP_NUMBER,
        modal: 'contact',
    },
    {
        id: 2,
        image: require('./src/cards/2.png'),
        link: VITRINE_URL,
    },
    {
        id: 3,
        image: require('./src/cards/3.png'),
        link: MIDIAKIT_PATH,
    },
];

const Keysbraga: React.FC = () => {
    const [activeCard, setActiveCard] = useState<ModalCard | null>(null);

    useEffect(() => {
        if (!activeCard) return;

        const onKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') setActiveCard(null);
        };

        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        window.addEventListener('keydown', onKeyDown);

        return () => {
            document.body.style.overflow = prevOverflow;
            window.removeEventListener('keydown', onKeyDown);
        };
    }, [activeCard]);

    return (
        <div className={styles.keysbraga}>
            <div className={styles.container}>
                <img src={perfil} alt="Keys Braga" className={styles.perfil} />
                <div className={styles.socialRow}>
                    <a
                        href={`https://wa.me/${WHATSAPP_NUMBER}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.socialLink}
                        aria-label="WhatsApp"
                    >
                        <WhatsappIcon height="22" color={ICON_COLOR} />
                    </a>
                    <a
                        href={`mailto:${EMAIL}`}
                        className={styles.socialLink}
                        aria-label="E-mail"
                    >
                        <svg
                            height="24"
                            width="24"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                        >
                            <path
                                fill={ICON_COLOR}
                                d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5L4 8V6l8 5 8-5v2z"
                            />
                        </svg>
                    </a>
                    <a
                        href={INSTAGRAM_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.socialLink}
                        aria-label="Instagram"
                    >
                        <InstagramIcon height="22" color={ICON_COLOR} />
                    </a>
                    <a
                        href={TIKTOK_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.socialLink}
                        aria-label="TikTok"
                    >
                        <TiktokIcon height="22" color={ICON_COLOR} />
                    </a>
                </div>
                <div className={styles.cards}>
                    {cardImages.map((card) =>
                        card.modal ? (
                            <button
                                type="button"
                                key={card.id}
                                className={styles.card}
                                onClick={() => setActiveCard(card)}
                                aria-label={`Abrir ${card.brand}`}
                            >
                                <img src={card.image} alt={card.brand} />
                            </button>
                        ) : card.link.startsWith('/') ? (
                            <Link to={card.link} key={card.id} className={styles.card}>
                                <img src={card.image} alt={`Card ${card.id}`} />
                            </Link>
                        ) : (
                            <a
                                href={card.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                key={card.id}
                                className={styles.card}
                            >
                                <img src={card.image} alt={`Card ${card.id}`} />
                            </a>
                        )
                    )}
                </div>
            </div>

            {activeCard && (
                <div
                    className={styles.modalOverlay}
                    onClick={() => setActiveCard(null)}
                    role="presentation"
                >
                    <div
                        className={styles.modal}
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="keysbraga-modal-title"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            type="button"
                            className={styles.modalClose}
                            onClick={() => setActiveCard(null)}
                            aria-label="Fechar"
                        >
                            ×
                        </button>

                        <p className={styles.modalEyebrow}>Parcerias</p>
                        <h2 id="keysbraga-modal-title" className={styles.modalBrand}>
                            {activeCard.brand}
                        </h2>
                        <div className={styles.contactActions}>
                            <a
                                href={`mailto:${activeCard.email}`}
                                className={styles.contactBtnEmail}
                            >
                                <svg
                                    height="22"
                                    width="22"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                    aria-hidden="true"
                                >
                                    <path
                                        fill="currentColor"
                                        d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5L4 8V6l8 5 8-5v2z"
                                    />
                                </svg>
                                <span>E-mail</span>
                            </a>
                            <a
                                href={`https://wa.me/${activeCard.whatsapp}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={styles.contactBtnWhatsapp}
                            >
                                <WhatsappIcon height="22" color="currentColor" />
                                <span>WhatsApp</span>
                            </a>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Keysbraga;
